import { createStyles } from 'core/utilities/theme';

export default createStyles({
  root: {
    marginBottom: '70px',
    '& .MuiTreeItem-content': {
      alignItems: 'start',
      '& .MuiTreeItem-iconContainer': {
        marginTop: '3px',
      },
    },
  },
  disableFocus: {
    '& .MuiTreeItem-content': {
      cursor: 'default',
      alignItems: 'start',
      '&.Mui-focused': {
        backgroundColor: 'inherit',
      },
      '& .MuiTreeItem-iconContainer': {
        marginTop: '3px',
      },
    },
  },
  visibilityButton: {
    display: 'inline-block',
    marginTop: '-2px',
    height: '24px',
  },
  treeItemText: {
    display: 'inline-block',
    width: '100%',
    wordBreak: 'break-word',
  },
  toggleButtonWrapper: {
    '& .MuiButtonGroup-root, & .MuiButton-root': {
      height: '22px',
    },
  },
});
